import logo from "../images/Logo.png";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Company Info */}
        <div>
          {/* Logo + Name */}
          <div className="flex items-center gap-3 mb-4">
            <img
              src={logo}
              alt="PC Enterprises Logo"
              className="h-12 w-auto object-contain"
            />
            <h3 className="text-xl font-semibold text-white">
              PC Enterprises
            </h3>
          </div>

          <p className="text-sm leading-relaxed">
            17, Naveen Park <br />
            Shyam Park, Sahibabad <br />
            Ghaziabad, 201005 <br />
            Uttar Pradesh, India
          </p>

          <p className="mt-4 text-sm">
            <span className="font-medium text-white">Email:</span>{" "}
            <a
              href="mailto:pcenterprises25@gmail.com"
              className="hover:text-white transition"
            >
              pcenterprises25@gmail.com
            </a>
            <br />
            <span className="font-medium text-white">Phone:</span>{" "}
            <a
              href="tel:9582730030"
              className="hover:text-white transition"
            >
              +91 9582730030
            </a>
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold text-white mb-4">
            Quick Links
          </h3>
          <ul className="space-y-3 text-sm">
            <li><a href="/" className="hover:text-white transition">Home</a></li>
            <li><a href="/about" className="hover:text-white transition">About Us</a></li>
            <li><a href="/services" className="hover:text-white transition">Gallery</a></li>
            <li><a href="/contact" className="hover:text-white transition">Contact</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-xl font-semibold text-white mb-4">
            Follow Us
          </h3>
          <div className="flex space-x-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-gray-800 rounded-full hover:bg-blue-600 transition"
            >
              <FaFacebookF />
            </a>
           
            <a
              href="https://www.linkedin.com/in/parasagarwalpcenterprises"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-gray-800 rounded-full hover:bg-blue-700 transition"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.instagram.com/pcenterpirses.offical?igsh=MXAyNzB3aTZtcGo1Zg%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-gray-800 rounded-full hover:bg-pink-600 transition"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 text-center py-5 text-sm">
        © {new Date().getFullYear()} PC Enterprises. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;